function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.474 19.826l3.156-3.15L8.805 8.87a4.446 4.446 0 000 6.293l4.669 4.663zm7.303-2.585c1.687.791 4.07.233 5.828-1.526 2.118-2.119 2.522-5.144.901-6.765-1.625-1.62-4.655-1.216-6.768.902-1.758 1.759-2.311 4.143-1.526 5.83A24985.6 24985.6 0 008.413 26.478l1.565 1.565 7.608-7.61 7.61 7.61 1.564-1.565-7.609-7.61 1.626-1.627z",
  fill: "#98AAB3",
  fillRule: "nonzero"
});

var SvgFoodAndDrink = function SvgFoodAndDrink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFoodAndDrink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/foodAndDrink.80f4c80a.svg";
export { ForwardRef as ReactComponent };